import { IMAGES_SIZES } from './constants';
const REGEX_EPS_FORMAT = /^(https:\/\/|http:\/\/|\/\/)?(.+)\/00\/s(?:\/.+)?\/z\/(.+)\/\$(?:_|(?:_(\d+)))?(?:\.(.*))?(\?(?:.*))?$/;
const REGEX_ZOOM_FORMAT = /^(https:\/\/|http:\/\/|\/\/)?(.+)\/images\/g\/(.+)\/(?:(?:s-l|s-w|s-h)(\d+)?)?(?:\.(.*))?(\?(?:.*))?$/;
export const getUrlPartsEpsFormat = (url) => url.match(REGEX_EPS_FORMAT); // [ fullUrl, protocol, baseUrl, zoomId, imageId, suffix, params]
export const getUrlPartsZoomFormat = (url) => url.match(REGEX_ZOOM_FORMAT); // [ fullUrl, protocol, baseUrl, zoomId, size,    suffix, params]
export const isEpsFormat = getUrlPartsEpsFormat;
export const isZoomFormat = getUrlPartsZoomFormat;
export const getSizeFromImageId = (imageId) => IMAGES_SIZES.find(size => size.imageId === Number(imageId))?.width ||
    undefined;
